module.exports = __webpack_public_path__ + "img/logo.e460f56a.png";